<script>
export default {
	name: 'znesekfilter-dropdown',
	props: {
		value: {
			type: Object,
			required: false
		}
	},
	methods: {
		click_potrdi (evt) {
			if (this.mode === '') {
				this.$emit('input', null);
				this.$refs.dropdown.hide();
				return;
			}
			if (this.mode === 'single') {
				if (!this.znesek) {
					return;
				}
				this.izbranZnesek = { value: this.znesek };
				this.label = this.znesek + ' €';
			} else if (this.mode === 'range') {
				if (!this.znesek_od || !this.znesek_do) {
					return;
				}
				this.izbranZnesek = { min: this.znesek_od, max: this.znesek_do };
				this.label = this.znesek_od + ' - ' + this.znesek_do + ' €';
			}
			this.$emit('input', this.izbranZnesek);
			this.$refs.dropdown.hide();
		},
		click_pocisti (evt) {
			this.clearForm();
			this.$emit('input', null);
			this.$refs.dropdown.hide();
		},
		clear () {
			this.clearForm();
		},
		clearForm () {
			this.izbranZnesek = null;
			this.label = null;
			this.mode = '';
			this.znesek = null;
			this.znesek_od = null;
			this.znesek_do = null;
		}
	},
	computed: {
		selectedTitle () {
			if (this.label) {
				return this.label;
			} else {
				return this.defaultItemLabel;
			}
		}
	},
	data: () => {
		return {
			izbranZnesek: null,
			label: null,
			mode: '',
			znesek: null,
			znesek_od: null,
			znesek_do: null,
			defaultItemLabel: 'Vse'
		}
	}
}
</script>
<template>
	<b-dropdown :text="selectedTitle" ref="dropdown">
		<b-dropdown-header>Znesek</b-dropdown-header>
		<b-dropdown-form class="znesek-dd">
			<b-row align-v="center">
				<b-col>
					<b-form-radio v-model="mode" name="mode" value="single">Točna vrednost</b-form-radio>
				</b-col>
				<b-col>
					<currency-input class="form-control" v-model="znesek" placeholder="Znesek"></currency-input>
				</b-col>
				<b-col></b-col>
			</b-row>
			<b-row align-v="center">
				<b-col>
					<b-form-radio v-model="mode" name="mode" value="range">Razpon</b-form-radio>
				</b-col>
				<b-col>
					<currency-input class="form-control" v-model="znesek_od" placeholder="Od"></currency-input>
				</b-col>
				<b-col>
					<currency-input class="form-control" v-model="znesek_do" placeholder="Do"></currency-input>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="auto" class="mr-auto"><b-button @click.prevent="click_pocisti">Počisti</b-button></b-col>
				<b-col cols="auto" ><b-button @click.prevent="click_potrdi" variant="primary">Potrdi</b-button></b-col>
			</b-row>
		</b-dropdown-form>
	</b-dropdown>
</template>
<style scoped lang="scss">
.znesek-dd {
	width: 30rem!important;

	.row {
		margin-top: 14px;
		margin-bottom: 14px;
	}
}
</style>
<style>
</style>


// WEBPACK FOOTER //
// src/components/DropdownFilters/ZnesekDropdown.vue